export type StartMethod =
  | StartMethodSemiAuto
  | StartMethodManual
  | StartMethodAuto;
export type StartMethodSemiAuto = 'semiauto';
export type StartMethodManual = 'manual';
export type StartMethodAuto = 'auto';

const StartMethodKeyValues = {
  manual: '手動',
  auto: '自動',
  semiauto: 'セミオート',
};
export const getStartMethodLabel = (startMethod: StartMethod) => {
  return StartMethodKeyValues[startMethod];
};
export const getOptions = () => {
  return Object.keys(StartMethodKeyValues).map((startMethod: string) => {
    return {
      id: startMethod,
      name: getStartMethodLabel(startMethod as StartMethod),
    };
  });
};
